import {APIService} from './api.service';

export const PARAMETERS: any = {};

export const fetchParameters = () => fetch(APIService.urls.FrontendParametersViewSet.get())
    .then(res => res.json())
    .then(config => Object.assign(PARAMETERS, config));
